import { useContext } from 'react';
import { DeleteEntityModalContext } from './DeleteEntityModalContext';

export const useDeleteEntityModal = () => useContext(DeleteEntityModalContext);
